var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Message.SelectImportContent"),
        width: "400px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "row",
              "align-items": "center",
              margin: "15px 0"
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("SeaExport.ImportBusinessNo")) + "：")
            ]),
            _c("el-input", {
              staticStyle: { width: "210px" },
              attrs: { no: "jobNo" },
              model: {
                value: _vm.jobNo,
                callback: function($$v) {
                  _vm.jobNo = $$v
                },
                expression: "jobNo"
              }
            }),
            _c(
              "el-button",
              {
                staticStyle: { margin: "0 10px" },
                attrs: { no: "filterJob", type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.findJob()
                  }
                }
              },
              [_vm._v("...")]
            )
          ],
          1
        ),
        _c("fieldset", [
          _c("legend", [_vm._v(_vm._s(_vm.$t("Message.ImportContent")))]),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                "padding-left": "30px"
              }
            },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { disabled: true },
                  model: {
                    value: _vm.defaultImportOrder.basicInfo,
                    callback: function($$v) {
                      _vm.$set(_vm.defaultImportOrder, "basicInfo", $$v)
                    },
                    expression: "defaultImportOrder.basicInfo"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.BasicInfo")))]
              ),
              _c(
                "el-checkbox",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lob === "SE",
                      expression: "lob === 'SE'"
                    }
                  ],
                  model: {
                    value: _vm.defaultImportOrder.booking,
                    callback: function($$v) {
                      _vm.$set(_vm.defaultImportOrder, "booking", $$v)
                    },
                    expression: "defaultImportOrder.booking"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Booking")))]
              ),
              _c(
                "el-checkbox",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lob === "SE",
                      expression: "lob === 'SE'"
                    }
                  ],
                  model: {
                    value: _vm.defaultImportOrder.prePlanBooking,
                    callback: function($$v) {
                      _vm.$set(_vm.defaultImportOrder, "prePlanBooking", $$v)
                    },
                    expression: "defaultImportOrder.prePlanBooking"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.prePlanBooking")))]
              ),
              _c(
                "el-checkbox",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lob === "SE" || _vm.lob === "AE",
                      expression: "lob === 'SE' || lob === 'AE'"
                    }
                  ],
                  model: {
                    value: _vm.defaultImportOrder.mbl,
                    callback: function($$v) {
                      _vm.$set(_vm.defaultImportOrder, "mbl", $$v)
                    },
                    expression: "defaultImportOrder.mbl"
                  }
                },
                [_vm._v(_vm._s(_vm.lob === "AE" ? "MAWB" : "MBL"))]
              ),
              _c(
                "el-checkbox",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lob === "SE" || _vm.lob === "AE",
                      expression: "lob === 'SE' || lob === 'AE'"
                    }
                  ],
                  model: {
                    value: _vm.defaultImportOrder.hbl,
                    callback: function($$v) {
                      _vm.$set(_vm.defaultImportOrder, "hbl", $$v)
                    },
                    expression: "defaultImportOrder.hbl"
                  }
                },
                [_vm._v(_vm._s(_vm.lob === "AE" ? "HAWB" : "HBL"))]
              ),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.defaultImportOrder.charge,
                    callback: function($$v) {
                      _vm.$set(_vm.defaultImportOrder, "charge", $$v)
                    },
                    expression: "defaultImportOrder.charge"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Charge")))]
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "row",
              "align-items": "center"
            }
          },
          [
            _c(
              "el-radio-group",
              {
                staticStyle: { "margin-top": "15px", "margin-bottom": "10px" },
                model: {
                  value: _vm.defaultImportOrder.isOverwritesDifference,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.defaultImportOrder,
                      "isOverwritesDifference",
                      $$v
                    )
                  },
                  expression: "defaultImportOrder.isOverwritesDifference"
                }
              },
              [
                _c("el-radio", { attrs: { label: true } }, [
                  _c("span", { staticStyle: { "font-size": "13px" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Message.DifferenceOverwritesTheOriginalValue")
                      )
                    )
                  ])
                ]),
                _c("el-radio", { attrs: { label: false } }, [
                  _c("span", { staticStyle: { "font-size": "13px" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Message.DifferenceRetainsTheOriginalValue")
                      )
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "row",
              "align-items": "center"
            }
          },
          [
            _c(
              "el-checkbox",
              {
                staticStyle: { "margin-top": "10px", "margin-bottom": "5px" },
                model: {
                  value: _vm.rememberChoose,
                  callback: function($$v) {
                    _vm.rememberChoose = $$v
                  },
                  expression: "rememberChoose"
                }
              },
              [
                _c("span", { staticStyle: { "font-size": "12px" } }, [
                  _vm._v(_vm._s(_vm.$t("Message.RememberToChoose")))
                ])
              ]
            )
          ],
          1
        )
      ]),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      ),
      _c("query-job-dialog", {
        attrs: {
          visible: _vm.queryJobDialog.visible,
          lob: _vm.lob,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.queryJobDialog, "visible", $event)
          },
          callback: function(row) {
            _vm.callbackSelectedJob(row)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }